<template>
  <div>
    <a-divider />
    <a-card :bordered="false">
      <a-breadcrumb style="margin-bottom: 10px" separator=">">
        <a-breadcrumb-item
          ><router-link to="/contest"
            >大赛列表</router-link
          ></a-breadcrumb-item
        >
        <a-breadcrumb-item>浏览大赛</a-breadcrumb-item>
      </a-breadcrumb>
      <a-row type="flex" justify="space-between" :gutter="40">
        <a-col :flex="_isMobile()?2:'450px'">
          <a-skeleton v-if="!info.contestCover_url"/>
          <img class="cover" v-if="info.contestCover_url" :src="info.contestCover_url" alt="">
        </a-col>
        <a-col :flex="_isMobile()?3:'auto'" class="info-right">
          <h3>{{info.contestName}}</h3>
          <p>{{info.contestStartTime}} - {{info.contestEndTime}}</p>
          <a-button size="large" type="primary" @click="appoVisible=true"> 我要报名 </a-button>
          <br><br>
          <p  class="gray"><pre>{{info.contestComment}}</pre></p>
        </a-col>
      </a-row>
    </a-card>
    <a-divider />
    <a-card :bordered="false">
        <h3>详细介绍</h3>
        <div class="html-content" v-html="info.html"></div>
    </a-card>

    <a-modal
      :visible="appoVisible"
      :maskClosable="false"
      title="我要预定"
      :destroyOnClose="true"
      @cancel="appoVisible=false"
      @ok="appointment"
    >
      <a-form>
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="appoInfo.realname" placeholder="请输入真实姓名/全名"></a-input>
        </a-form-item>
         <a-form-item label="手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="appoInfo.phone" placeholder="请输入联系手机号码"></a-input>
        </a-form-item>
        <a-form-item label="微信号" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="appoInfo.wechat" placeholder="请输入联系微信号码"></a-input>
        </a-form-item>
        <a-form-item label="专业" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input v-model="appoInfo.major" placeholder="请输入专业"></a-input>
        </a-form-item>
         <a-form-item label="地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea v-model="appoInfo.address" placeholder="请输入证书或资料邮寄地址，联系人，电话"></a-textarea>
        </a-form-item>
        <a-form-item label="人数" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input-number size="small" :min="1" :max="999" :default-value="1" v-model="appoInfo.num"/>
          <a-divider type="vertical"/>
            <span>￥{{(info.contestPrice/100*appoInfo.num).toFixed(2)}}</span>
        </a-form-item>
         <a-form-item label="备注" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea :auto-size="{ minRows: 2, maxRows: 10 }" v-model="appoInfo.comment" placeholder="请输入数量，以及留言或需要备注的信息。"></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import {mixinDevice} from '@/utils/mixin.js'

export default {
  mixins: [mixinDevice],
  components: {},
  data() {
    return {
      id: "",
      info: {},
      appoVisible: false,
      appoInfo: {
        num: 1,
        realname: "",
        phone: "",
        wechat: "",
        address: "",
        major: "",
        unit: "",
        comment: "",
        appointmentType: 2,
        relId: "",
      },
      appoSuccess: false,
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      tenantConfig:{}
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.appoInfo.relId = this.id;
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.getInfo();
  },
   mounted(){
    window.document.title = this.tenantConfig.brandName + " " + "师训赛事详情"
  },
  methods: {
    getInfo() {
      getAction("/teaching/teachingContest/contestDetail", { id: this.id }).then(
        (res) => {
          if (res.success) {
            this.info = res.result;
          }
        }
      );
    },
    appointment() {
      console.log(this.appoInfo);
      if (this.appoSuccess) {
        this.$message.info("已经预约了");
        return;
      }
      if (
        !this.appoInfo.realname ||
        !this.appoInfo.phone ||
        !this.appoInfo.address
      ) {
        this.$message.info("请填写完整");
        return;
      }
      postAction("/teaching/teachingAppointment/add", this.appoInfo).then(
        (res) => {
          if (res.success) {
            this.$message.success("预定成功");
            this.appoSuccess = true;
            this.appoVisible = false;
          }
        }
      );
    },
  },
};
</script>

<style lang="less" scoped>
.gray {
  color: gray;
}
.cover {
  width: 100%;
}
.html-content{
  overflow: hidden;
  /deep/img{
    height: auto;
    max-width: 100%;
  }
}
</style>